import {
  canonicalUrlIsChalkDev,
  canonicalUrlIsChalkPreprod,
  canonicalUrlIsLocal,
  useCurrentCanonicalUrl,
} from "@/utils/hooks/url/use-current-url";
import { useDANGEROUSisChalkEmployee } from "@/utils/hooks/use-is-chalk-employee";
import { useRouteInfo } from "@/utils/hooks/url/use-route-info";
import { useMemo } from "react";

export function useEnvironmentTitle(title: string) {
  const isChalkEmployee = useDANGEROUSisChalkEmployee();
  const { environmentId } = useRouteInfo();
  const currentUrl = useCurrentCanonicalUrl();

  return useMemo(() => {
    const urlIsStaging =
      canonicalUrlIsChalkDev(currentUrl) || canonicalUrlIsChalkPreprod(currentUrl);
    const urlIsLocal = canonicalUrlIsLocal(currentUrl);

    const envSection = isChalkEmployee && environmentId ? `${environmentId} ` : "";
    const urlSection = isChalkEmployee
      ? urlIsStaging
        ? "(staging) "
        : urlIsLocal
          ? "(local) "
          : "(prod) "
      : "";
    const titleSection = title ? `${title} | ` : "";

    return `${envSection}${urlSection}${titleSection}Chalk`;
  }, [currentUrl, environmentId, isChalkEmployee, title]);
}
